module.exports = __webpack_public_path__ + "img/selected.2917752d.svg";